import { render, staticRenderFns } from "./IconHomeLinear.vue?vue&type=template&id=6bc7fb4d&scoped=true"
import script from "./IconHomeLinear.vue?vue&type=script&lang=js"
export * from "./IconHomeLinear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc7fb4d",
  null
  
)

export default component.exports